<div class="calendar-container">
  <div class="header-title-page">
    <h1 class="title-header">Calendario</h1>
  </div>

  <div class="calendar-header">
    <div class="view-selector">
      <button 
        class="button is-small is-primary" 
        [class.is-outlined]="view !== CalendarView.Month"
        (click)="setView(CalendarView.Month)">
        <span>Mes</span>
      </button>
      <button 
        class="button is-small is-primary" 
        [class.is-outlined]="view !== CalendarView.Week"
        (click)="setView(CalendarView.Week)">
        <span>Semana</span>
      </button>
    </div>
    <h2 class="current-month">{{ getCurrentPeriod() }}</h2>
    <div class="calendar-controls">
      <button class="button is-small is-primary" (click)="previousMonth()">
        <span>Anterior</span>
      </button>
      <button class="button is-small is-primary is-outlined" (click)="todayMonth()">
        <span>Actual</span>
      </button>
      <button class="button is-small is-primary" (click)="nextMonth()">
        <span>Siguiente</span>
      </button>
    </div>
  </div>

  <div class="calendar-wrapper">
    <div *ngIf="loading" class="loading-container">
      <app-spinner></app-spinner>
    </div>

    <mwl-calendar-month-view
      *ngIf="!loading && view === CalendarView.Month"
      [viewDate]="viewDate"
      [events]="events"
      [locale]="locale"
      [weekStartsOn]="weekStartsOn"
      [activeDayIsOpen]="false"
      (dayClicked)="dayClicked($event.day)"
      [cellTemplate]="customCellTemplate">
    </mwl-calendar-month-view>

    <!-- Vista semanal personalizada -->
    <div *ngIf="!loading && view === CalendarView.Week" class="week-view-custom">
      <div class="week-header">
        <div class="week-day-name" *ngFor="let dayName of weekDayNames">
          {{ dayName }}
        </div>
      </div>
      <div class="week-days">
        <div 
          *ngFor="let day of weekDays" 
          class="week-day-cell"
          [class.today]="isToday(day.date)"
          [style.background-color]="getDayColor(day)"
          (click)="onWeekDayClick(day)">
          <div class="custom-cell-content">
            <div class="cal-cell-top">
              <span class="cal-day-number">{{ day.date | date: 'd' }}</span>
            </div>
            <div class="cal-events" *ngIf="getDayInfo(day) as info">
              <div class="cal-event-title">{{ info }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template
    #customCellTemplate
    let-day="day"
    let-locale="locale">
    <div class="custom-cell-content"
         [style.background-color]="day.events.length > 0 ? day.events[0].color?.secondary : 'transparent'">
      <div class="cal-cell-top">
        <span class="cal-day-number">{{ day.date | date: 'd' }}</span>
      </div>
      <div class="cal-events" *ngIf="day.events.length > 0">
        <div *ngFor="let event of day.events" class="cal-event-title">
          {{ event.title }}
        </div>
      </div>
    </div>
  </ng-template>

  <div class="legend">
    <div class="legend-item">
      <span class="legend-color working-day"></span>
      <span>Laborable</span>
    </div>
    <div class="legend-item">
      <span class="legend-color holiday"></span>
      <span>Festivo</span>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal" [class.is-active]="showModal">
  <div class="modal-background" (click)="closeModal()"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ formatDate(editingDay.date) }}
      </p>
      <button class="delete" aria-label="close" (click)="closeModal()"></button>
    </header>
    <section class="modal-card-body">
      <div class="field">
        <label class="label">Tipo de día</label>
        <div class="control">
          <label class="radio">
            <input 
              type="radio" 
              name="dayType" 
              [(ngModel)]="editingDay.type" 
              value="laborable">
            Laborable
          </label>
          <label class="radio">
            <input 
              type="radio" 
              name="dayType" 
              [(ngModel)]="editingDay.type" 
              value="no laborable">
            Festivo
          </label>
        </div>
      </div>

      <div *ngIf="editingDay.type === 'laborable'" class="working-hours">
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">Hora de inicio</label>
              <div class="control">
                <input 
                  class="input" 
                  type="time" 
                  [value]="getTimeValue(editingDay.start_hour)"
                  (change)="setStartTime($event)"
                  placeholder="08:00">
              </div>
            </div>
          </div>

          <div class="column is-6">
            <div class="field">
              <label class="label">Hora de fin</label>
              <div class="control">
                <input 
                  class="input" 
                  type="time" 
                  [value]="getTimeValue(editingDay.end_hour)"
                  (change)="setEndTime($event)"
                  placeholder="17:00">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <div class="buttons">
        <button class="button is-primary" (click)="saveDay()">Guardar</button>
        <button class="button" (click)="closeModal()">Cancelar</button>
      </div>
    </footer>
  </div>
</div>
